import { View, Text, StyleSheet, BackHandler, StatusBar } from "react-native";
import React, { useEffect } from "react";
import { useNavigation } from "@react-navigation/native";
import { setLoggedIn } from "../../../redux/auth/authSlice";
import { dispatch } from "../../../redux/store";
import GlobalStyles from "../../../globalStyles/globalStyles";
import AuthIcons from "../../../assets/Icons/AuthIcons";
import { Colors } from "../../../globalStyles/ColorConfig";

type SuccessProps = {
  route: any;
};

export default function AuthSuccess({ route }: SuccessProps) {
  const navigation = useNavigation();

  const { accessToken, refreshToken } = route.params;


  useEffect(() => {
    function handleBackButton() {
      BackHandler.exitApp();
      return true;
    }
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      handleBackButton
    );
    return () => backHandler.remove();
  }, [navigation]);

  // add userinfo

  useEffect(() => {
    setTimeout(() => {
      dispatch(setLoggedIn({accessToken: accessToken, refreshToken: refreshToken} ));
    }, 2000);
  }, [route]);

  return (
    <View style={styles.container}>
      <StatusBar translucent  backgroundColor={'transparent'} barStyle={'light-content'}  />
      <AuthIcons.SuccessIcon />
      <Text
        style={[
          GlobalStyles.heading3,
          {
            color: "#FDFBF9",
            fontFamily: "EBGaramondMedium",
            fontSize: 32,
            lineHeight: 34,letterSpacing: -0.3,
            marginTop: 20,
            paddingHorizontal: 20,
            textAlign: "center",
          },
        ]}
      >
        Your number has been verified
      </Text>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.darkGreen,
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  successText: {},
});
